//
// BIRDDataType.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var BIRDDataType = {
    NONE:0,
    DOUBLE:1,
    INT:2,
    DATE:3,
    TIME:4,
    DATETIME:5,
    STRING:6
};
export default BIRDDataType;
